import React, { useEffect, useRef } from 'react';
import { registerModal } from '../../utils/backButtonManager';

const UpgradeModal = ({ featureKey, message, onClose }) => {
    const onCloseRef = useRef(onClose);
    useEffect(() => { onCloseRef.current = onClose; });

    useEffect(() => {
        const unregister = registerModal(() => {
            onCloseRef.current?.();
        });
        return unregister;
    }, []);

    const handleUpgrade = () => {
        window.location.pathname = '/billing';
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform transition-all animate-in fade-in zoom-in duration-200">
                <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 p-6 text-center text-white relative">
                    <button 
                        onClick={onClose}
                        className="absolute top-4 right-4 text-white/80 hover:text-white"
                    >
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <div className="mx-auto bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                        </svg>
                    </div>
                    <h3 className="text-2xl font-bold">Unlock Premium Power</h3>
                </div>
                
                <div className="p-6">
                    <p className="text-gray-600 dark:text-gray-300 text-center mb-6">
                        {message || "This feature requires an upgraded subscription plan."}
                    </p>
                    
                    {/* In a real app, this would dynamically fetch pricing difference from PricingService */}
                    <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 mb-6 border border-gray-100 dark:border-gray-600">
                        <div className="flex justify-between items-center mb-2">
                            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Current Plan</span>
                            <span className="font-bold text-gray-800 dark:text-white">Gold</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">Required Plan</span>
                            <span className="font-bold text-yellow-600 dark:text-yellow-400">Gold+</span>
                        </div>
                    </div>

                    <div className="space-y-3">
                        <button 
                            onClick={handleUpgrade}
                            className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-4 rounded-xl shadow-lg shadow-yellow-500/30 transition-all active:scale-[0.98]">
                            Upgrade Now
                        </button>
                        <button 
                            onClick={onClose}
                            className="w-full bg-transparent hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 font-semibold py-3 px-4 rounded-xl transition-colors"
                        >
                            Maybe Later
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpgradeModal;
